import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";

/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Paper, ColorBatch } from 'components';
import { dateTimeFormat, BORROWER_ACTION_TYPE, borrowerActionTypeName, borrowerActionTypeColorMap } from 'enums';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var add_action = BORROWER_ACTION_TYPE.add_action,
    update_action = BORROWER_ACTION_TYPE.update_action;

var BorrowerHistoryTab = function BorrowerHistoryTab(_ref) {
  var _borrower$history;

  var borrower = _ref.borrower;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref2) {
      var css = _ref2.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u0441\u0442\u043E\u0440\u0438\u044F"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("table", {
    className: "list-table"
  }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("th", null, "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B"), ___EmotionJSX("th", null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"), ___EmotionJSX("th", null, "\u0422\u0438\u043F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435"))), ___EmotionJSX("tbody", null, borrower === null || borrower === void 0 ? void 0 : (_borrower$history = borrower.history) === null || _borrower$history === void 0 ? void 0 : _borrower$history.map(function (el) {
    var _el$user;

    return ___EmotionJSX("tr", {
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("td", null, moment(el === null || el === void 0 ? void 0 : el.created_at).isValid() ? moment(el === null || el === void 0 ? void 0 : el.created_at).format(dateTimeFormat) : 'N/A'), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : (_el$user = el.user) === null || _el$user === void 0 ? void 0 : _el$user.name), ___EmotionJSX("td", null, ((el === null || el === void 0 ? void 0 : el.action) === add_action || (el === null || el === void 0 ? void 0 : el.action) === update_action) && (el === null || el === void 0 ? void 0 : el.data)), ___EmotionJSX("td", null, ___EmotionJSX(ColorBatch, {
      type: borrowerActionTypeColorMap[el === null || el === void 0 ? void 0 : el.action],
      fontSize: "1rem",
      margin: "0 0 0 6px"
    }, borrowerActionTypeName[el === null || el === void 0 ? void 0 : el.action])));
  }))))))));
};

BorrowerHistoryTab.propTypes = {
  borrower: PropTypes.object
};
export default BorrowerHistoryTab;